import script from "./AdminAnalyticsDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnalyticsDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnalyticsDashboardView.vue?vue&type=style&index=0&id=175b68ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175b68ca"]])

export default __exports__